import { render, staticRenderFns } from "./CaricoCarroConvoglio.vue?vue&type=template&id=16b85c02&scoped=true&"
import script from "./CaricoCarroConvoglio.vue?vue&type=script&lang=js&"
export * from "./CaricoCarroConvoglio.vue?vue&type=script&lang=js&"
import style0 from "./CaricoCarroConvoglio.vue?vue&type=style&index=0&id=16b85c02&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b85c02",
  null
  
)

export default component.exports